import { useIntl } from 'react-intl';

import { SearchableDropdownField } from 'ui-components/components/dropdown';

import { useSortedStrings } from '../../hooks/use-sorted-translations';
import { DEFAULTS } from '../../ship-from/components/ship-from-dropdown/constants';
import { messages } from '../messages';

/**
 * @typedef {import('../../prop-types/intl-types.d.ts').MessageDescriptor} MessageDescriptor
 */
/**
 * @typedef {import('ui-components/components/dropdown/dropdown-types.d.ts').DropdownInlineMessageType} DropdownInlineMessageType
 */

/**
 * @typedef {object} ShipFromDropdownOptions
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {object} ShipFromValidation
 * @property {string|MessageDescriptor} [helperText]
 * @property {DropdownInlineMessageType} [helperTextType]
 */

const sortOptions = {
  labelProp: 'name',
};

const getOptionLabel = (option) => option.name;
const getOptionValue = (option) => option.id;

/**
 * @param {object} props
 * @param {string} [props.id]
 * @param {boolean} [props.isDisabled]
 * @param {(newShipFromId: string) => void} props.onChange
 * @param {string} props.selectedShipFromId
 * @param {ShipFromDropdownOptions[]} props.shipFroms
 * @param {ShipFromValidation} [props.validation]
 * @returns {JSX.Element}
 */
export const ShipFromSearchableDropdown = ({
  id,
  isDisabled = false,
  onChange,
  selectedShipFromId,
  shipFroms,
  validation = DEFAULTS.validation,
}) => {
  const intl = useIntl();
  const shipFromsSorted = useSortedStrings(shipFroms, sortOptions);

  const isUnknownShipFrom = selectedShipFromId && !shipFromsSorted.find((s) => s.id === selectedShipFromId);
  const customAddressOption = isUnknownShipFrom ? { id: selectedShipFromId, name: intl.formatMessage(messages.customAddress) } : undefined;

  return (
    <SearchableDropdownField
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      id={id}
      inlineMessage={validation.helperText}
      inlineMessageType={validation.helperTextType}
      isDisabled={isDisabled}
      onItemSelected={onChange}
      options={shipFromsSorted}
      selectedItemValue={isUnknownShipFrom ? undefined : selectedShipFromId}
      selectedOption={customAddressOption}
    />
  );
};
